import { c as _c } from "react/compiler-runtime";
import { IcoCheckCircle16 } from '@onefootprint/icons';
import type { Actor, PlaybookVersionNoGraph } from '@onefootprint/request-types/dashboard';
import { cx } from 'class-variance-authority';
import { format } from 'date-fns';
import { useTranslation } from 'react-i18next';
import { useVersion } from '@/features/playbook-version-badge';
interface PlaybookVersionDisplayProps {
  createdFromVersion?: number;
  disableNonExecutableVersions?: boolean;
  isSelected: boolean;
  onClick: () => void;
  playbookVersion: PlaybookVersionNoGraph;
}
const PlaybookVersionDisplay = t0 => {
  const $ = _c(43);
  const {
    createdFromVersion,
    disableNonExecutableVersions,
    isSelected,
    onClick,
    playbookVersion
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "versionDropdown"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("playbook-builder", t1);
  const {
    text
  } = useVersion(playbookVersion);
  let t2;
  if ($[1] !== t) {
    t2 = author => {
      if (!author) {
        return null;
      }
      if (author.kind !== "organization" && author.kind !== "firm_employee") {
        return null;
      }
      if (author.kind === "organization") {
        if (author.firstName && author.lastName) {
          return `· ${t(_temp)} ${author.firstName} ${author.lastName}`;
        }
        return `· ${t(_temp2)} ${author.email}`;
      }
      const name = [author.firstName, author.lastName].filter(Boolean).join(" ").trim();
      const display = name || author.email;
      if (display) {
        return `· ${t(_temp3)} ${display} (${t(_temp4)})`;
      }
      return `· ${t(_temp5)} ${t(_temp6)}`;
    };
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const getAuthorName = t2;
  const authorName = getAuthorName(playbookVersion.author);
  let t3;
  if ($[3] !== playbookVersion.version || $[4] !== t) {
    t3 = t(_temp7, {
      version: playbookVersion.version
    });
    $[3] = playbookVersion.version;
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const playbookVersionDisplay = t3;
  let t4;
  if ($[6] !== playbookVersion.createdAt) {
    t4 = format(playbookVersion.createdAt, "yyyy-MM-dd, hh:mm a");
    $[6] = playbookVersion.createdAt;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const playbookVersionDateDisplay = t4;
  const disabled = disableNonExecutableVersions && !playbookVersion.isExecutable;
  const t5 = !disabled;
  let t6;
  if ($[8] !== isSelected || $[9] !== t5) {
    t6 = cx("flex flex-col items-start px-3 py-2 rounded w-full transition-colors duration-200", {
      "bg-senary/70": isSelected,
      "hover:bg-hover cursor-pointer": t5
    });
    $[8] = isSelected;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const t7 = isSelected ? undefined : onClick;
  const t8 = !isSelected;
  let t9;
  if ($[11] !== isSelected || $[12] !== t8) {
    t9 = cx("text-label-2 text-ellipsis whitespace-nowrap", {
      "text-accent": isSelected,
      "text-primary": t8
    });
    $[11] = isSelected;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== text) {
    t10 = text && <span> · {text}</span>;
    $[14] = text;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== playbookVersionDisplay || $[17] !== t10 || $[18] !== t9) {
    t11 = <div className={t9}>{playbookVersionDisplay}{t10}</div>;
    $[16] = playbookVersionDisplay;
    $[17] = t10;
    $[18] = t9;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== isSelected) {
    t12 = isSelected ? <IcoCheckCircle16 color="accent" /> : null;
    $[20] = isSelected;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== t12) {
    t13 = <div>{t12}</div>;
    $[22] = t12;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== t11 || $[25] !== t13) {
    t14 = <div className="flex justify-between items-center w-full mb-1">{t11}{t13}</div>;
    $[24] = t11;
    $[25] = t13;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  let t15;
  if ($[27] !== authorName || $[28] !== playbookVersionDateDisplay) {
    t15 = <div className="text-caption-2 text-tertiary max-md:text-left max-md:wrap-anywhere">{playbookVersionDateDisplay} {authorName}</div>;
    $[27] = authorName;
    $[28] = playbookVersionDateDisplay;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] !== createdFromVersion || $[31] !== t) {
    t16 = createdFromVersion !== undefined && <div className="text-caption-2 text-tertiary">{t(_temp8, {
        version: createdFromVersion
      })}</div>;
    $[30] = createdFromVersion;
    $[31] = t;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] !== playbookVersion.versionDescription) {
    t17 = playbookVersion.versionDescription && <div className="text-body-2 text-primary mt-3 text-left">"{playbookVersion.versionDescription}"</div>;
    $[33] = playbookVersion.versionDescription;
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  let t18;
  if ($[35] !== disabled || $[36] !== t14 || $[37] !== t15 || $[38] !== t16 || $[39] !== t17 || $[40] !== t6 || $[41] !== t7) {
    t18 = <button type="button" className={t6} onClick={t7} disabled={disabled}>{t14}{t15}{t16}{t17}</button>;
    $[35] = disabled;
    $[36] = t14;
    $[37] = t15;
    $[38] = t16;
    $[39] = t17;
    $[40] = t6;
    $[41] = t7;
    $[42] = t18;
  } else {
    t18 = $[42];
  }
  return t18;
};
export default PlaybookVersionDisplay;
function _temp($) {
  return $.by;
}
function _temp2($_0) {
  return $_0.by;
}
function _temp3($_1) {
  return $_1.by;
}
function _temp4($_2) {
  return $_2.footprint;
}
function _temp5($_3) {
  return $_3.by;
}
function _temp6($_4) {
  return $_4.footprint;
}
function _temp7($_5) {
  return $_5.versionAbbreviation;
}
function _temp8($_6) {
  return $_6.createdFrom;
}